import config from 'config';
import { SHIPPING_MODEL } from 'core/domains';
import { select } from 'core/middlewares/utilities';

import type { RootState } from 'core/store';

/**
 * Get default shippingModel from user
 *
 */
export function* getDefaultShippingModel() {
  const shippingModel: RootState['user']['data']['shippingModel'] = yield select(
    ({ user }: RootState) => user.data.shippingModel,
  );
  return shippingModel.default;
}

export function* getAvailablesDeliveries() {
  const withdrawal: RootState['user']['data']['shippingModel']['availables'] = yield select(
    ({ user }: RootState) =>
      user.data.shippingModel?.availables?.filter(
        (model) =>
          model.code === config.pickupStore ||
          model.code === SHIPPING_MODEL.KEY_ACCOUNT_PICKUP_STORE,
      ),
  );

  return withdrawal?.length
    ? withdrawal[0].deliveries.map((delivery) => delivery.isWithdrawalCenter && delivery)
    : [];
}

export function* getUser() {
  const data: RootState['user']['data']['shippingModel'] = yield select(
    ({ user }: RootState) => user.data,
  );

  return data;
}

export type UserData = RootState['user']['data'];
export type UserDefaultShippingModel = RootState['user']['data']['shippingModel']['default'];
export type UserAvailableDeliveries = {
  isWithdrawalCenter: boolean;
  distributionCenterCode: number;
};
